import React from 'react';
import { Checkbox } from 'primereact/checkbox';
import { FormattedMessage } from 'react-intl';
import { Gr8piFormattedDate } from '../../../components/Gr8piFormattedDateTime';

const GpiPartnersContactAgreement = ({
  updateAgreement,
  agreedToBeContactedByGpiReseller,
  gpiResellerContactAgreementUpdatedOn,
}) => {
  return (
    <>
      <div>
        <Checkbox
          id="agreedToBeContactedByGpiReseller"
          value={agreedToBeContactedByGpiReseller}
          onChange={(event) => updateAgreement(event)}
          checked={!!agreedToBeContactedByGpiReseller}
        />
        <span> </span>
        <label htmlFor="updateGpiResellerAgreement" className="p-checkbox-label">
          <FormattedMessage
            id="user.communication-settingst.gpi-partners-contact-agreement"
            defaultMessage="Information from GPI Partners (your GPI reseller, if any), including newsletters, marketing, etc."
            tagName="strong"
          />
        </label>
      </div>
      <br />
      <div>
        <FormattedMessage id="user.communication-settings.updatedOn" defaultMessage="Updated on: " tagName="strong" />
        <span>
          {gpiResellerContactAgreementUpdatedOn && (
            <Gr8piFormattedDate dateValue={gpiResellerContactAgreementUpdatedOn} />
          )}
        </span>
      </div>
    </>
  );
};

export default GpiPartnersContactAgreement;
